module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title",
    style: ({
      marginTop: (_vm.isPC ? '30px' : '80px')
    })
  }, [_vm._v(_vm._s(_vm.title))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ee12b8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Title.vue
// module id = 712
// module chunks = 1